<div class="state error">
  <strong>Unable to load data.</strong><span>{{ message }}</span>
</div>
